var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PickMenu',{class:{ active: _vm.$store.state.pickMenu.showSettingMenu },attrs:{"listMenu":_vm.settings,"maxHeightClass":'mh-screen-n54'}})}
var staticRenderFns = []

export { render, staticRenderFns }